// reference: https://easings.net/
export const EasingFunctions = {
	easeInSine: (n: number) => 1 - Math.cos((n * Math.PI) / 2),
	easeInCubic: (n: number) => Math.pow(n, 3),
	easeInCirc: (n: number) => 1 - Math.sqrt(1 - Math.pow(n, 2)),
	easeOutSine: (n: number) => Math.sin((n * Math.PI) / 2),
	easeOutCubic: (n: number) => 1 - Math.pow(1 - n, 3),
	easeOutCirc: (n: number) => Math.sqrt(1 - Math.pow(n - 1, 2)),
}
